import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  position: relative;
  align-items: flex-start;
  background-color: var(--white);
  display: flex;
  flex-direction: row;
  font-family: IBM Plex Sans;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  overflow: hidden;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
  padding: 16px 0;
`;

export const TitleContainer = styled.div`
  margin-bottom: 20px;
  padding: 0 16px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const FilterSortContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border-bottom: 1px solid #e5e7eb;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FilterLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #666;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const FilterDropdownWrap = styled.div`
  width: fit-content;
  min-width: 0;
  .text-container p {
    white-space: nowrap;
  }
  & > div {
    width: fit-content;
  }
  & > div > div {
    padding: 0 0 0 12px !important;
    background-color: #ffffff !important;
    border-color: #d1d5db !important;
    border-radius: 20px;
    box-shadow: none;
  }
  & > div > div > div {
    flex-grow: 0 !important;
  }
  & > div > div .text-container {
    flex-grow: 0 !important;
    padding: 0 4px 0 0 !important;
  }
`;

export const FilterDropdown = styled.select`
  padding: 10px 32px 10px 12px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: #ddd;
`;

export const SortContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SortLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #666;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const SortButton = styled.button`
  padding: 8px 16px;
  border: 1px solid ${(props) => (props.active ? '#7200E0' : '#ddd')};
  border-radius: 20px;
  background-color: ${(props) => (props.active ? '#7200E0' : '#fff')};
  color: ${(props) => (props.active ? '#fff' : '#666')};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #7200E0;
    color: ${(props) => (props.active ? '#fff' : '#7200E0')};
    background-color: ${(props) => (props.active ? '#7200E0' : '#fff')};
  }
`;

export const TableContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  background-color: #fff;
`;

export const TableHeaderRow = styled.tr``;

export const TableHeaderCell = styled.th`
  padding: 16px;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

export const HeaderCellContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e9ecef;

  &:hover {
    background-color: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TemplateName = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;

export const TemplateType = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #666;
`;

export const SharedBy = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #666;
`;

export const Subject = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #666;
`;

export const SharedOn = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #666;
`;

export const ActionButtons = styled.td`
  padding: 16px;
  display: flex;
  gap: 8px;
`;

